import React from 'react'
import PropTypes from 'prop-types'

//store
import {observer} from 'mobx-react'
import userState from '../store/userState'
import events from '../store/events'
import profile from '../store/profile'
import panels from '../store/panels';
//router
import {Redirect} from 'react-router-dom'

@observer

class Logout extends React.Component {
  componentDidMount(){
    this.logout();
  }
  logout(){
    userState.handleLogout();
    events.emptyEvent();
    profile.emptyProfile();
    panels.emptyPanel();
  }
  render () {
    if(!userState.login){
      return <Redirect to ='/login' />
    }
    return(null)
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout.js